// extracted by mini-css-extract-plugin
export var chevron = "_2a-d";
export var disabled = "_2a-b";
export var error = "_2a-c";
export var hideBorder = "_2a-1";
export var icon = "_2a-e";
export var input = "_2a-0";
export var large = "_2a-f";
export var open = "_2a-9";
export var placeholder = "_2a-a";
export var regular = "_2a-5";
export var singleRowInput = "_2a-2";
export var singleSelectInput = "_2a-3 _2a-0";
export var small = "_2a-4";
export var spinnerContainer = "_2a-i";
export var tag = "_2a-7";
export var tagsContainer = "_2a-8";
export var tagsInput = "_2a-6 _2a-0";
export var xSmall = "_2a-g";
export var xxSmall = "_2a-h";